import React, { Component } from 'react';
import { connect } from 'react-redux';

import { navigate } from 'libs/router';

import ActionButton from 'components/buttons/action-button/ActionButton';
import SVGIcon from 'components/svg-icon/SVGIcon';
import AccessContainer from './access-container/AccessContainer';

import { hideLoading, showLoading } from 'redux-store/reducers/loading-reducer';
import { activateUserAccount } from '../reducers/account';

import { t } from 'utils/language';

import '../common/access-actions.scss';

type Props = {
  dispatch: any,
  token: string,
  userId: string
};

type State = {
  error: boolean
};

class ActivateUserAccountForm extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      error: false
    };
  }

  componentDidMount() {
    const { dispatch, userId, token } = this.props;
    dispatch(showLoading('<ActivateUserAccountForm />'));
    dispatch(activateUserAccount({
      userId,
      token,
      invalidTokenMessage: t('invalid_activation_token')
    }))
      .then(() => {
        dispatch(hideLoading('<ActivateUserAccountForm />'));
        navigate.to('/login?activation=1');
      })
      .catch(() => {
        this.setState({ error: true });
        dispatch(hideLoading('<ActivateUserAccountForm />'));
      });
  }

  render() {
    const { error } = this.state;
    return (
      <AccessContainer type="activate-user">
        <p className="access-container__icon">
          <SVGIcon
            name="lock-dark"
            width={240}
            height={160}
          />
        </p>
        {
          !error &&
            <p className="access-container__description" data-qa="access-activation">
              {t('activating_account')}
            </p>
        }
        {
          error &&
            <p className="access-container__description">
              {t('activating_account_error_message')}
            </p>
        }
        {
          error &&
            <div className="access-actions access-actions--center">
              <ActionButton link="/users/request-activation-email">
                {t('next_action_button')}
              </ActionButton>
            </div>
        }
      </AccessContainer>
    );
  }
}

export default connect()(ActivateUserAccountForm);
